import axiosWatcher from '@/utils/axios-watcher'
import { resetRouter } from '@/boot/create-router'

export default function(Vue, options = {}) {
    var { router, store, config } = options

    // listen 登录失效
    axiosWatcher.$on("sessionLost", () => {
        // 清空会话信息
        store.commit('clearUser')
        // 跳转到登录页面
        router.replace({ name: "login" })
    })
}